export default {"src":"/_next/static/media/flag-fr.427b820b.svg","height":2,"width":3,"blurWidth":0,"blurHeight":0};